import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import { loadCatalog } from "src/business/catalog/apiCatalog";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { RemoteData } from "src/common/RemoteData";
import { PageUrl } from "src/routes/PageUrl";

import { CDSFormStore } from "../CatalogRecordForm/CDSFormStore";
import {
  CatalogRecordFormContext,
  createCatalogRecordFormLoader,
} from "../CatalogRecordForm/createCatalogRecordFormLoader";

export type NewRecordData = {
  catalog: ZCatalog;
};

export const newRecordStore = makeAutoObservable({
  async init(catalogId: string) {
    this.setCatalogId(catalogId);
    try {
      this.setData({ status: "wait" });
      const catalog = await loadCatalog(catalogId);
      this.setData({ status: "ready", result: { catalog } });
      this.setCDSFormStore(
        new CDSFormStore(createCatalogRecordFormLoader(catalog), {}),
      );
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  catalogId: "",
  setCatalogId(id: string) {
    this.catalogId = id;
  },
  data: { status: "none" } as RemoteData<NewRecordData>,
  setData(newData: RemoteData<NewRecordData>) {
    this.data = newData;
  },
  cdsFormStore: null as CDSFormStore<CatalogRecordFormContext> | null,
  setCDSFormStore(store: CDSFormStore<CatalogRecordFormContext>) {
    this.cdsFormStore = store;
  },
  // form: new MFormStore(),
  get breadcrumbs(): BreadcrumbItem[] {
    const { data } = this;
    const res: BreadcrumbItem[] = [
      { title: "Каталоги", page: PageUrl.catalogs },
    ];
    if (data.status === "ready") {
      res.push({
        title: data.result.catalog.name,
        page: PageUrl.records,
        params: { id: this.catalogId },
      });
    }
    res.push({ title: "Новая запись" });
    return res;
  },
});
